import { render, staticRenderFns } from "./CloseTab.vue?vue&type=template&id=706aa283"
import script from "./CloseTab.vue?vue&type=script&lang=js"
export * from "./CloseTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports